module.exports = __webpack_public_path__ + "img/onboarding-image6.fc02a019.png";